import { render, staticRenderFns } from "./Pep-statements-search.vue?vue&type=template&id=3f9650ed&scoped=true"
import script from "./Pep-statements-search.vue?vue&type=script&lang=js"
export * from "./Pep-statements-search.vue?vue&type=script&lang=js"
import style0 from "./Pep-statements-search.vue?vue&type=style&index=0&id=3f9650ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9650ed",
  null
  
)

export default component.exports